import type { PageCardFilterInput } from '../../models/page-filter.model';

/**
 * Batch-hydrates page card data (charts/tables). Returns Boolean; results arrive on WebSocket.
 *
 * `pageFilters` is AWSJSON — pass a JSON string of {@link PageCardFilterInput}[] when active.
 */
export const queryGetPageData = `
	query getPageData(
		$pageId: ID!
		$timeDimension: TimeDimensionsInput
		$accountId: ID
		$pageFilters: AWSJSON
		$refresh: Boolean
		$requestId: ID!
		$requester: ID!
	) {
		getItem {
			pageData(
				pageId: $pageId
				timeDimension: $timeDimension
				accountId: $accountId
				pageFilters: $pageFilters
				refresh: $refresh
				requestId: $requestId
				requester: $requester
			)
		}
	}
`;

export interface GetPageDataVariables {
	/** IAM/public analytics only. Omit on Cognito-authenticated Jepto Reports. */
	accountId?: string;
	pageId: string;
	timeDimension: { dateRange: string[] };
	requestId: string;
	requester: string;
	refresh?: boolean;
}

/** Builds `getPageData` variables; serializes page filter selections to AWSJSON. */
export function buildGetPageDataRequest(
	variables: GetPageDataVariables,
	pageFilters: PageCardFilterInput[] = []
): { query: string; variables: Record<string, unknown> } {
	const gqlVariables: Record<string, unknown> = {
		pageId: variables.pageId,
		timeDimension: variables.timeDimension,
		requestId: variables.requestId,
		requester: variables.requester,
	};

	const accountId = variables.accountId?.trim();
	if (accountId) {
		gqlVariables.accountId = accountId;
	}

	if (pageFilters.length > 0) {
		gqlVariables.pageFilters = JSON.stringify(pageFilters);
	}

	if (variables.refresh === true) {
		gqlVariables.refresh = true;
	}

	return {
		query: queryGetPageData,
		variables: gqlVariables,
	};
}
